module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sectionKey === 0) ? _c('div', [_c('div', {
    staticClass: "city-title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.name) + "\n      ")])]) : _c('div', {
    ref: "citydropdown",
    staticClass: "dropdown-nav cursor",
    class: {
      open: _vm.dropdown
    }
  }, [_c('div', {
    staticClass: "currentSection",
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "dropdown-title"
  }, [_vm._v(_vm._s(_vm.city.City.name))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-arrow"
  }, [_c('img', {
    attrs: {
      "src": '/img/arrow-b.svg'
    }
  })])]), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    staticClass: "allCities"
  }, [_c('div', {
    staticClass: "city-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityFilter),
      expression: "cityFilter"
    }],
    attrs: {
      "placeholder": "Select a city or type to search"
    },
    domProps: {
      "value": (_vm.cityFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cityFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-search",
    on: {
      "click": function($event) {
        _vm.dropdown = false
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.citiesGrouped), function(citiesGroup, index) {
    return _c('div', {
      staticClass: "cityGroup"
    }, _vm._l((citiesGroup), function(city, indexx) {
      return _c('div', [(_vm.lastRegion(index, indexx, city)) ? _c('div', {
        staticClass: "dropdown-region",
        class: {
          first: index === 0
        }
      }, [_vm._v("\n            " + _vm._s(city.Region.name) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "dropdown-title"
      }, [_c('a', {
        attrs: {
          "href": '/cities/view/' + city.City.slug
        }
      }, [_vm._v(_vm._s(city.City.name) + " - "), _c('span', {
        staticClass: "country-name"
      }, [_vm._v(_vm._s(city.City.country))])])])])
    }))
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9ca797a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityDropdown.vue
// module id = 305
// module chunks = 1